import { aggregate } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { directusClient } from '../../services/directusClient/directusClient.ts';
import { usePromoterItemQuery } from '../promoter/usePromoterItemQuery.ts';

type EventStatus = 'created' | 'published' | 'declined';

export const useEventsCountQuery = ({ status }: { status: EventStatus }) => {
  const { data } = usePromoterItemQuery();

  return useQuery({
    queryKey: ['events', 'count', { status, promoterId: data?.id }],
    queryFn: async () => {
      const result = await directusClient.request(
        aggregate('events', {
          aggregate: { count: '*' },
          query: {
            filter: { promoter: { _eq: data?.id }, status: { _eq: status } },
          },
        }),
      );

      return Number(result[0]?.count ?? 0);
    },
    enabled: !!data?.id,
  });
};
